import { Core } from '@springtree/eva-services-core';
import productDetailState from './product-detail-state.js';
import buildServiceState from '../../builders/build-service-state.js';
const productDetailBundleState = buildServiceState({
    allowEmptyRequest: false,
    key: 'productDetailBundle',
    service: Core.GetBundleProductDetails,
    beforeRequest: ({ req, get }) => {
        const currentProduct = get(productDetailState.response);
        const productId = currentProduct && currentProduct.Result?.product_id;
        // Fetch bundle details if this is a bundle product
        // 2048 is configurable product
        //
        const productTypes = currentProduct?.Result?.product_types || [];
        const isBundle = productTypes.indexOf(2048) !== -1;
        if (!productId || !isBundle) {
            return;
        }
        const newRequest = {
            BundleProductID: productId,
            ...req,
        };
        return newRequest;
    },
});
export default productDetailBundleState;
//# sourceMappingURL=product-detail-bundle-state.js.map